import { render, staticRenderFns } from "./_copyLink.vue?vue&type=template&id=14d154fb&scoped=true"
import script from "./_copyLink.vue?vue&type=script&lang=js"
export * from "./_copyLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d154fb",
  null
  
)

export default component.exports